import {AUTH_LOGIN, AUTH_CHECK,AUTH_LOGOUT, PROFILE, UPDATE_PASSWORD, UPDATE_PROFILE, FORGOT_PASSWORD, RESET_PASSWORD_FORM, RESET_PASSWORD } from 'store/actions/auth';
import Http from 'helpers/Http';

const initialState = {
    isAuthenticated: false,
    user: null,
    loader:false,
};

//login 
const authLogin = (state, payload) => {
  const { data } = payload;
  localStorage.setItem('access_token', data?.body.access_token);
  localStorage.setItem('user', JSON.stringify(data?.body));
  Http.defaults.headers.common.Authorization = `Bearer ${data?.body.access_token}`;
  const stateObj = {
    ...state,
      isAuthenticated: true,
      user:data?.body
    };
  return stateObj;
};

//check auth
const checkAuth = (state) => {
  const stateObj = {
    ...state,
    isAuthenticated: !!localStorage.getItem('access_token'),
    user: JSON.parse(localStorage.getItem('user')),
  };
  if (state.isAuthenticated) {
    Http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'access_token',
    )}`;

  }
  return stateObj;
};

//logout
const authLogout = (state) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  const stateObj = {
    ...state,
    isAuthenticated: false,
    user: null,
  };
  return stateObj;
};

//get profile
const getProfile = (state, payload) => {
  const { body } = payload;
   const stateObj = {
    ...state,
    isAuthenticated: true,
    user:body,
  };
  return stateObj;
};

//update profile
const updateProfile = (state, payload) => {
  const { body } = payload;
  const stateObj = {
    ...state,
    isAuthenticated: true,
  };
  return stateObj;
};

//update password
const updatePassword = (state, payload) => {
  const { data } = payload;
  const stateObj = {
    ...state,
    isAuthenticated: true,
  };
  return stateObj;
};

//forgotPassword
const forgotPassword = (state) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  const stateObj = {
    ...state,
    isAuthenticated: false,
    user: null,
  };
  return stateObj;
};

//resetPasswordForm
const resetPasswordForm = (state) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  const stateObj = {
    ...state,
    isAuthenticated: false,
    user: null,
  };
  return stateObj;
};

//resetPassword
const resetPassword = (state) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user');
  const stateObj = {
    ...state,
    isAuthenticated: false,
    user: null,
  };
  return stateObj;
};

const Auth = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case AUTH_LOGIN:
          return authLogin(state, payload);
        case AUTH_CHECK:
          return checkAuth(state, payload);
        case AUTH_LOGOUT:
          return authLogout(state);
        case PROFILE:
          return getProfile(state, payload);
        case UPDATE_PROFILE:
          return updateProfile(state, payload);
        case UPDATE_PASSWORD:
          return updatePassword(state, payload);
        case FORGOT_PASSWORD:
          return forgotPassword(state);
        case RESET_PASSWORD_FORM:
          return resetPasswordForm(state);
        case RESET_PASSWORD:
          return resetPassword(state);
        default:
        return state;
    };
}
export default Auth;